import useTrans from "@/hooks/useTrans"
import { Container, Grid, Stack, Typography } from "@mui/material"
import Image from "next/image"
import ArrowRightIcon from "@/assets/icons/arrow-right.svg"
import HomeWhyToChooseImage from "@/assets/images/home-why-to-choose.png"
import Link from "next/link"
import navbarLinks from "@/constants/navbarLinks"

const ItemInfo = ({ title, description }: { title: string; description: string }) => {
  const trans = useTrans()

  return (
    <Stack
      alignItems='start'
      gap={1}
      className='px-6 sm:px-8 py-5 border-l-[3px] border-solid border-secondary hover:border-primary'
    >
      <Typography className='text-neutral-1000 font-bold text-lg sm:text-2xl'>{title}</Typography>
      <Typography className='text-neutral-600 text-sm'>{description}</Typography>
      <Link
        className='text-primary text-sm flex items-center gap-2 no-underline hover:text-primary/80'
        href={navbarLinks.dashboard}
        target='_blank'
      >
        <span>{trans.home.discover_now}</span>
        <Image src={ArrowRightIcon} alt='open-icon' width={16} height={16} />
      </Link>
    </Stack>
  )
}

const WhyChooseRenecLend = () => {
  const trans = useTrans()

  return (
    <Container maxWidth='xl' className='py-10 sm:py-20' id='why-choose-renec-lend'>
      <Stack alignItems='start' gap={1}>
        <Typography className='text-neutral-1000 text-left font-montserrat text-2xl sm:text-[2.5rem] font-bold leading-tight'>
          {trans.home.why_choose_renec_lend}
        </Typography>
        <Typography className='text-sm sm:text-base text-neutral-600 text-left sm:max-w-md'>
          {trans.home.backed_by_renec_foundation}
        </Typography>
      </Stack>

      <Grid container className='mt-5 sm:mt-10' spacing={{ xs: 3, sm: 0 }}>
        <Grid item xs={12} sm={12} md={6} className='flex justify-items-center items-center'>
          <Stack gap={0} className='sm:w-3/4'>
            <ItemInfo title={trans.home.lower_nterest_rates} description={trans.home.we_offers_the_most} />
            <ItemInfo
              title={trans.home.first_fiat_lending_protocol}
              description={trans.home.introducing_our_revolutionary}
            />
            <ItemInfo
              title={trans.home.liquidity_mining_with_airdrop}
              description={trans.home.earn_rewards_by_providing}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Image src={HomeWhyToChooseImage} alt='image-why-choose-renec-lend' className='m-auto' unoptimized priority />
        </Grid>
      </Grid>
    </Container>
  )
}

export default WhyChooseRenecLend
